import { useMemo } from "react"
import { IKPIContextValue } from "./types"

/**
 * Custom hook to extract KPI-specific analytics properties with memoization.
 * Only recomputes when primitive analytics values change.
 *
 * Note: Dashboard properties (modelId, instrumentId, selectedMode, etc.) are inherited
 * automatically through provider nesting - they should NOT be extracted here.
 *
 * @param kpiContext - The KPI context value
 * @returns Memoized KPI analytics properties
 */
export function useExtractKPIContextProperties(
  kpiContext: Partial<IKPIContextValue>,
) {
  const selectedTab = kpiContext.selectedTab
  const selectedGroupName = kpiContext.selectedGroup?.name
  const selectedGroupId = kpiContext.selectedGroup?.id

  // Return memoized object depending only on primitive values
  return useMemo(
    () => ({
      selectedTab,
      selectedGroup: selectedGroupName || selectedGroupId,
    }),
    [selectedTab, selectedGroupName, selectedGroupId],
  )
}
